import {gql} from "@apollo/client";
export default gql`
  query jobTemplateById($id: Int!){
    jobTemplateById(id: $id) {
      id
      templateName
      employerId
      managerId
      workTypeId
      peopleNeeded
      street
      city
      region
      unit
      floor
      description
      isActive
      breakMins
      latitude
      longitude
      locationInstruction
      gears
      skills
      jobTemplateGear {
        gear {
          isActive
          id
          gearName
          frenchGearName
          createdAt
        }
        gearId
        id
        createdAt
      }
      jobTemplateSkill {
        skill {
          frenchSkillName
          id
          isActive
          skillName
          createdAt
        }
        id
        skillId
        createdAt
      }
      isPrivate
      tags
      breakMins
      isBreakPaid
      employer {
        id
        firstName
        lastName
      }
      manager {
        id
        firstName
        lastName
      }
      workType {
        id
        label
        frenchName
      }
    }
  }
`;